import { Map, List } from 'immutable';

import * as types from './types';

const initialState = new Map({
  count: 0,
  loading: false,
  filters: Map(),
  items: List(),
});

const devicesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.DEVICE_LIST_GET.REQUEST:
      return state.set('loading', true);
    case types.DEVICE_LIST_GET.SUCCESS: {
      return state.withMutations((mutable) => {
        mutable.set('loading', false);
        mutable.set('items', List(payload));
      });
    }
    case types.DEVICE_LIST_GET.FAILURE:
      return state.set('loading', false);
    case types.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default devicesReducer;
